<div class="container-fluid pt-3 pb-5">
  <div class="card" style="border: 1px solid #ccc; border-radius: 5px;">
    <div class="card-header" style="background: #2b3a4a; color: white; padding: 10px; font-weight: bold;">
      Profit & Loss
    </div>
    <div class="card-body">
      <form class="row mb-3">
        <div class="col-md-3">
          <label>Data Source</label>
          <select class="form-control"><option>Live Data</option><option>Backup Data</option></select>
        </div>
        <div class="col-md-3">
          <label>From</label>
          <input type="date" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>To</label>
          <input type="date" class="form-control" />
        </div>
        <div class="col-md-3 d-flex align-items-end">
          <button class="btn btn-primary w-100" style="background: #2b3a4a; border: none;">Search</button>
        </div>
      </form>
      
      <div class="table-responsive">
        <table class="table table-bordered table-striped text-center">
          <thead style="background: #e4e4e4;">
            <tr>
              <th>Market ID</th>
              <th>Event Name</th>
              <th>Settled Date</th>
              <th>Comm.</th>
              <th>Net P/L</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" style="padding: 20px; color: #777;">No records found.</td>
            </tr>
          </tbody>
          <tfoot style="background: #f8f9fa;">
            <tr>
              <td colspan="4" class="text-right"><strong>Total:</strong></td>
              <td><strong>0.00</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
